import { createAction, props } from '@ngrx/store';
import { ICardData, ICardModel } from '@partners/api';

export class CardActions {
  static reset = createAction('[Card] Reset State');
  static load = createAction('[Card] Load');
  static loadSuccess = createAction('[Card] Load Success', props<{ model: ICardModel; data: ICardData }>());
  static loadFailure = createAction('[Card] Load Failure', props<{ error: any }>());
  static submit = createAction('[Card] Submit');
  static submitSuccess = createAction('[Card] Submit Success', props<{ model: ICardModel }>());
  static submitFailure = createAction('[Card] Submit Failure', props<{ error: any }>());
}
